import React, { useState } from 'react';
import './HowitWorksSSS.css';

const HowitWorksSSS = () => {
    // Butonların açılıp kapanma durumunu tutacak state'ler
    const [openIndex, setOpenIndex] = useState(null); // Hangi butonun açık olduğunu takip ediyoruz

    // Buton tıklama işlevi
    const handleButtonClick = (index) => {
        // Aynı butona tıklanınca kapanacak, farklı bir butona tıklayınca o açılacak
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="SSS-section">
            <h1 className="SSS-baslik">Sık Sorulan Sorular</h1>
            <h3 className="SSS-baslik-metin">Lorem ipsum dolor sit amet consectetur adipiscing eli mattis sit phasellus mollis sit aliquam sit nullam.</h3>
            <div className="alt-baslik-genel">
                <h3 className="SSS-alt-baslik">Lingify.co</h3>
                <p className="SSS-alt-baslik-metin">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mattis nunc augue vel lacinia erat euismod ut. Sed eleifend tellus nonole tincidunt aliquet. Fusce aliquam mi felis.</p>
            </div>
            <div className="SSS-buton-container">
                {/* Buton 1 */}
                <button className="SSS-buton" onClick={() => handleButtonClick(1)}>
                    <h3 className="buton-metin">Lingify.co</h3>
                    <h3 className="buton-sembol">+</h3>
                </button>
                {/* Buton 1 alt metin alanı */}
                {openIndex === 1 && (
                    <div className="SSS-alt-metin">
                        <p>Bu, Lingify.co hakkında daha fazla bilgi içeren metindir.</p>
                    </div>
                )}

                {/* Buton 2 */}
                <button className="SSS-buton" onClick={() => handleButtonClick(2)}>
                    <h3 className="buton-metin">Lingify.co</h3>
                    <h3 className="buton-sembol">+</h3>
                </button>
                {/* Buton 2 alt metin alanı */}
                {openIndex === 2 && (
                    <div className="SSS-alt-metin">
                        <p>Bu, Lingify.co hakkında daha fazla bilgi içeren metindir.</p>
                    </div>
                )}

                {/* Buton 3 */}
                <button className="SSS-buton" onClick={() => handleButtonClick(3)}>
                    <h3 className="buton-metin">Lingify.co</h3>
                    <h3 className="buton-sembol">+</h3>
                </button>
                {/* Buton 3 alt metin alanı */}
                {openIndex === 3 && (
                    <div className="SSS-alt-metin">
                        <p>Bu, Lingify.co hakkında daha fazla bilgi içeren metindir.</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default HowitWorksSSS;
